var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReloadMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_5087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.99971C18.0598 9.99971 17.5 10.5587 17.5 11.2497C17.5 13.3177 15.818 14.9997 13.75 14.9997H7.5V13.4372C7.5 13.0673 7.28211 12.7317 6.94414 12.5802C6.60547 12.4333 6.21094 12.4919 5.93359 12.7419L2.80859 15.5544C2.61289 15.7302 2.5 15.9841 2.5 16.2497C2.5 16.5153 2.61293 16.7685 2.81008 16.9466L5.93508 19.7591C6.10938 19.9177 6.33594 19.9997 6.5625 19.9997C6.69188 19.9997 6.8209 19.9729 6.94359 19.9192C7.28125 19.7692 7.5 19.4333 7.5 19.0622V17.4997H13.75C17.1961 17.4997 20 14.6958 20 11.2497C20 10.5583 19.4414 9.99971 18.75 9.99971ZM6.25 4.99971H12.4648L12.5 6.56221C12.5 6.93209 12.7179 7.26768 13.0559 7.41924C13.1797 7.47236 13.3086 7.49971 13.4023 7.49971C13.6294 7.49971 13.8543 7.4167 14.0301 7.25924L17.1551 4.44674C17.3867 4.26924 17.5 4.01533 17.5 3.71455C17.5 3.41377 17.3871 3.1958 17.1899 3.01768L14.0649 0.205176C13.7896 -0.0413864 13.3934 -0.102441 13.0559 0.0452542C12.7187 0.23166 12.4648 0.567285 12.4648 0.937207L12.5 2.49971H6.25C2.80391 2.49971 0 5.30439 0 8.74971C0 9.44072 0.559766 9.99971 1.25 9.99971C1.94023 9.99971 2.5 9.44072 2.5 8.74971C2.5 6.6833 4.18359 4.99971 6.25 4.99971Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_5087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReloadMap);
export default __webpack_public_path__ + "static/media/icon_reload_map.36c69430c40234ce5c8c50b7533a574e.svg";
export { ForwardRef as ReactComponent };